import { ChevronDownIcon } from '@langchain/untitled-ui-icons';

import { ReactNode, useState } from 'react';

import { Text } from '@/design-system';
import { cn } from '@/utils/tailwind';

export const ExpandableTraceInformation = (props: {
  content: string;
  header: ReactNode;
  className?: string;
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <div className={cn('px-3 pb-3', props.className)}>
      <div className="flex flex-col rounded-lg bg-secondary text-sm">
        <div
          className="flex cursor-pointer items-center justify-between rounded-lg px-4 py-2 hover:bg-tertiary"
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          <div className="flex items-center gap-3 overflow-hidden">
            <Text variant="md" className="flex-none">
              {props.header}
            </Text>
            {isCollapsed && (
              <Text variant="xs" className="truncate text-tertiary">
                {props.content}
              </Text>
            )}
          </div>
          {!isCollapsed && (
            <ChevronDownIcon
              className={cn('size-4 shrink-0 transition-transform')}
            />
          )}
        </div>

        {!isCollapsed && (
          <div className="max-h-[300px] overflow-y-auto px-4 py-2 ">
            <Text variant="xs" className="text-tertiary">
              {props.content}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};
